import {
  primaryMain,
  primaryDark,
  primaryLight,
  contrastText,
  backgroundDefault,
  backgroundPaper,
  lead600,
  lead900,
  navBarSurface,
  navBarInactiveCircle,
  gray25,
  surfaceDefault,
  surfaceCard,
  surfaceElevated,
  surfaceProduct,
  surfaceInput,
  surfaceMuted,
  surfaceSelectedHighlight,
  borderSubtle,
  starRating,
} from './colors';

export const palette = {
  mode: 'light',
  primary: {
    main: primaryMain,
    light: primaryLight,
    dark: primaryDark,
    contrastText,
  },
  secondary: {
    /** Secondary text / outlined labels */
    main: lead600,
    light: gray25,
    /** Contained dark buttons (chumbo) — NOT primary.dark (orange800) */
    dark: lead900,
    contrastText,
  },
  background: {
    default: backgroundDefault,
    paper: backgroundPaper,
  },
  text: {
    primary: lead900,
    secondary: lead600,
  },
  surface: {
    default: surfaceDefault,
    card: surfaceCard,
    elevated: surfaceElevated,
    product: surfaceProduct,
    input: surfaceInput,
    muted: surfaceMuted,
    selectedHighlight: surfaceSelectedHighlight,
  },
  border: {
    subtle: borderSubtle,
  },
  nav: {
    surface: navBarSurface,
    inactive: navBarInactiveCircle,
  },
  starRating,
};
